import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { AUTH_KEY, AuthActionTypes } from '@app/core/auth/auth.reducer';

@Injectable()
export class AuthEffects {
  private actions$ = inject<Actions<Action>>(Actions);
  private localStorage = inject(LocalStorageService);


  login = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGIN),
      tap(() =>
        this.localStorage.setItem(AUTH_KEY, {isAuthenticated: true})
      )
    ),
    { dispatch: false }
  );

  logout = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGOUT),
      tap(() =>
        this.localStorage.setItem(AUTH_KEY, {isAuthenticated: false})
      )
    ),
    { dispatch: false }
  );
}
